import { IMAGE_MODELS } from '@/lib/ai-agent/model-constants';
import { selectRealismModel } from '@/lib/realism/select-realism-model';

/**
 * Which tier a slot edit from this popover will actually route to.
 *
 * Mirrors the server's own decision instead of duplicating it: an edit always
 * sends exactly one reference (the slot's current image), and the popover's
 * only tier-moving input is the keep-identity checkbox, which
 * usePostMediaEdit turns into `referenceImageRoles: ['person']` — the input
 * selectRealismModel treats as identity-critical.
 *
 * Verified parity with the server (server/api/generate-image.post.ts:518-527):
 * for this exact call path the popover never sends `premium` (the field
 * doesn't exist in that route's request schema at all) or a
 * `realismTemplateId`, so the server's own selectRealismModel call reduces to
 * `{ referenceCount: 1, hasPersonReference: keepIdentity }` — exactly what
 * this function passes. If either side ever grows a new tier-moving input for
 * this path, update both together (see the parity test in
 * __tests__/predictEditTier.test.ts).
 *
 * Never hardcodes a model id; the ids live in model-constants.ts.
 */
export function predictEditTier(args: { keepIdentity: boolean }): 'pro' | 'standard' {
  const model = selectRealismModel({
    referenceCount: 1,
    hasPersonReference: args.keepIdentity,
  });
  return model === IMAGE_MODELS.PRO ? 'pro' : 'standard';
}
